'use strict';

import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';

/* ---------------------------
   Pluginy (deklaracje)
   --------------------------- */

class InvertDeltaPlugin extends ScrollbarPlugin {
  static pluginName = 'invertDelta';

  static defaultOptions = {
    events: [],
  };

  transformDelta(delta, fromEvent) {
    if (this.shouldInvertDelta(fromEvent)) {
      return {
        x: delta.y,
        y: delta.x,
      };
    }

    return delta;
  }

  shouldInvertDelta(fromEvent) {
    return this.options.events.some(rule => fromEvent.type.match(rule));
  }
}

/* ModalPlugin deklarujemy, ale NIE rejestrujemy globalnie tutaj.
   Zarejestrujemy go jedynie wtedy, gdy wywołasz smoothScrollbarInit z enableModal: true */
class ModalPlugin extends ScrollbarPlugin {
  static pluginName = 'modal';

  static defaultOptions = {
    open: false,
  };

  transformDelta(delta) {
    return this.options.open ? { x: 0, y: 0 } : delta;
  }
}

/* ---------------------------
   Rejestracja pluginów które chcesz globalnie (tylko invertDelta)
   --------------------------- */
Scrollbar.use(InvertDeltaPlugin);

/* ---------------------------
   Inicjalizator
   - options: opcje przekazywane do Scrollbar.init
   - selector: selektor elementu
   - opts: dodatkowe ustawienia funkcjonalne (enableModal: boolean)
   --------------------------- */
export function smoothScrollbarInit(
  options = {},
  selector = '#page-smooth-scroll',
  { enableModal = true } = {}
) {
  const el = document.querySelector(selector);
  if (!el) {
    console.warn(`smoothScrollbarInit: nie znaleziono selektora ${selector}`);
    return null;
  }

  // jeśli użytkownik chce modal dla tej instancji -> zarejestruj plugin przed init
  // (Scrollbar.use jest idempotentne — rejestracja wielokrotna nie psuje)
  if (enableModal) {
    Scrollbar.use(ModalPlugin);
  }

  const root = document.getElementsByTagName('html')[0];
  root.classList.add('page-smooth-scroll');

  const scrollbar = Scrollbar.init(el, {
    ...options,
  });

  // Dodaj helpery TYLKO kiedy enableModal === true
  if (enableModal) {
    scrollbar.setModalOpen = function (isOpen = true) {
      this.updatePluginOptions('modal', { open: !!isOpen });
    };

    scrollbar.isModalOpen = function () {
      try {
        return !!this.getOptions().plugins?.modal?.open;
      } catch (e) {
        return false;
      }
    };
  }

  return scrollbar;
}

/* ---------------------------
   Przykłady użycia:

   // 1) Instancja z modal (możesz potem wywołać setModalOpen)
   const sbWithModal = smoothScrollbarInit({ damping: 0.06 }, '#page-smooth-scroll', { enableModal: true });
   // otwierasz menu:
   sbWithModal?.setModalOpen(true);
   // zamykasz:
   sbWithModal?.setModalOpen(false);

   // 2) Inicjalizacja dla innego selektora BEZ modala
   const sbNoModal = smoothScrollbarInit({ damping: 0.06 }, '#other-scroll-area', { enableModal: false });
   // ta instancja nie ma setModalOpen / isModalOpen

   --------------------------- */
